/**
 * @flow
 * @relayHash 6f5561402cc26b3cab84f350b8890522
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AccountUpdateInput = {|
  id: string,
  name: string,
|};
export type UpdateAccountMutationVariables = {|
  data: AccountUpdateInput
|};
export type UpdateAccountMutationResponse = {|
  +updateAccount: {|
    +id: string
  |}
|};
export type UpdateAccountMutation = {|
  variables: UpdateAccountMutationVariables,
  response: UpdateAccountMutationResponse,
|};
*/


/*
mutation UpdateAccountMutation(
  $data: AccountUpdateInput!
) {
  updateAccount(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "AccountUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateAccount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "AccountModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateAccountMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateAccountMutation",
    "id": null,
    "text": "mutation UpdateAccountMutation(\n  $data: AccountUpdateInput!\n) {\n  updateAccount(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2ffdaafda63c5d35872a19197a02bad3';
module.exports = node;
